import * as React from 'react';
import * as styled from './styled';
import {IconActiveFolder, IconNotActiveFolder} from 'icons';
import {FolderProps} from './types';

/**
 * The folder.
 * @param {FolderProps} props
 * @return {React.ReactElement<FolderProps>}
 * @constructor
 */
export default function Folder(
  {
    name,
    isActive,
    onClick,
  }: FolderProps,
): React.ReactElement<FolderProps> {
  /**
   * Render icon.
   * @return {JSX.Element}
   */
  function renderIcon(): JSX.Element {
    return (
      <styled.IconWrapper isActive={isActive}>
        {isActive ? (
          <IconActiveFolder />
        ) : (
          <IconNotActiveFolder />
        )}
      </styled.IconWrapper>
    );
  }

  /**
   * Render name.
   * @return {JSX.Element}
   */
  function renderName(): JSX.Element {
    return (
      <styled.Name>
        {name}
      </styled.Name>
    );
  }

  return (
    <styled.Wrapper isActive={isActive} onClick={onClick}>
      {renderIcon()}
      {renderName()}
    </styled.Wrapper>
  );
}
